<template>
	<div>
        <div class="password-rule" >
					<!-- 密码为6-20位,数字、字母组合 -->
					<div class="text-left"><span class="iconfont icon-dian"></span>1. 密码只能包含数字、字母和特殊字符</div>
					<div class="text-left"><span class="iconfont icon-dian"></span>2. 长度8-22位</div>
					<div class="text-left"><span class="iconfont icon-dian"></span>3. 必须包含大写字母</div>
					<div class="text-left"><span class="iconfont icon-dian"></span>4. 必须包含小写字母</div>
					<div class="text-left"><span class="iconfont icon-dian"></span>5. 必须包含至少一个特殊字符 !@#$%^&*</div>
					
					
				</div>
	</div>
</template>

<script>
	
	export default {
		name: 'Passrule',

		data() {
			return {

			}
		},
		created() {
		
		},
		methods: {
			
	
		},
	
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
		.password-rule{
            padding: 10px 0;
            color: #333;
            font-size: 13px;
        }
		.password-rule div{
			line-height: 20px;
		}

</style>